import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import { CSSProperties } from "react";

export const container: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

export const body: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  overflow: "auto",
  backgroundColor: greys.palePaleGrey,
};
